/**
 * SetTitleFromResource Handler для HeaderPage
 * Встановлює заголовок з ресурсу якщо він не встановлений
 * 
 * @param params - параметри з headerPageContext
 */
export const SetTitleFromResource = ({ props }: any) => {
    if (!props?.title && props?.storages?.resource?.title) {
        props.title = props.storages.resource.title
    }
}
